module.exports = __webpack_public_path__ + "img/Mermaid.c0f3b6e0.jpeg";